import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ButtonInfoSmall } from "../generic/common/ButtonInfoSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
export var ModalInfoButton = function (_a) {
    var onClick = _a.onClick;
    if (onClick === undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "modal-footer__info-button-wrapper" },
        React.createElement(ButtonInfoSmall, { onClick: onClick, children: React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }) })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/ModalInfoButton.tsx
// module id = 661
// module chunks = 3